var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_227_4490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0006 8.33337C27.0007 8.33337 8.33398 27 8.33398 50C8.33398 73 27.0007 91.6667 50.0006 91.6667C73.0006 91.6667 91.6673 73 91.6673 50C91.6673 27 73.0006 8.33337 50.0006 8.33337ZM41.6673 70.8334L20.834 50L26.709 44.125L41.6673 59.0417L73.2923 27.4167L79.1673 33.3334L41.6673 70.8334Z",
    fill: "#27E39F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_227_4490"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.facae065b28d4db820774af8e06ae9e5.svg";
export { ForwardRef as ReactComponent };